/**
 * Supabase auth email links land on /auth/confirm.
 *
 * The default confirm link opens Supabase /auth/v1/verify, then redirects to
 * emailRedirectTo. Signup used window.location.origin, so the iOS app and
 * preview deploys sent a redirect that is not on the allow list, and Supabase
 * showed an error page. The app now sends authConfirmUrl(): REACT_APP_APP_URL,
 * otherwise the http(s) page origin, otherwise https://app.pacarion.com/auth/confirm.
 * PKCE ?code= links also fail on a different device. token_hash + verifyOtp
 * works from any device and does not depend on that redirect. Hash
 * access_token and ?code= are still accepted for older emails.
 */

const AUTH_CONFIRM_PATH = '/auth/confirm';
const AUTH_CONFIRM_URL = 'https://app.pacarion.com/auth/confirm';

const OTP_TYPES = ['signup', 'email', 'recovery', 'magiclink', 'invite', 'email_change'];

function locationParts(location) {
  const loc = location || (typeof window !== 'undefined' ? window.location : null) || {};
  const path = String(loc.pathname || '/').replace(/\/+$/, '') || '/';
  const query = new URLSearchParams(String(loc.search || '').replace(/^\?/, ''));
  const fragment = new URLSearchParams(String(loc.hash || '').replace(/^#/, ''));
  const pick = (key) => query.get(key) || fragment.get(key) || '';
  return { path, query, fragment, pick };
}

function readAuthConfirm(location) {
  const { path, pick } = locationParts(location);
  const tokenHash = pick('token_hash');
  const code = pick('code');
  const accessToken = pick('access_token');
  const rawType = pick('type').toLowerCase();
  const errorDescription = pick('error_description');
  const errorCode = pick('error_code');
  const onPath = path === AUTH_CONFIRM_PATH;
  const hasAuthError = Boolean(errorDescription || errorCode);
  if (!onPath && !tokenHash && !code && !accessToken && !hasAuthError) return null;
  return {
    tokenHash,
    code,
    accessToken,
    type: OTP_TYPES.includes(rawType) ? rawType : 'signup',
    error: errorDescription || errorCode || '',
  };
}

function confirmSuccessTitle(type) {
  if (type === 'recovery') return 'Choose a new password';
  if (type === 'magiclink') return 'You are signed in';
  if (type === 'email_change') return 'Email updated';
  return 'Email ready';
}

function confirmSuccessBody(type) {
  if (type === 'recovery') {
    return 'Your reset link worked. Choose a new password, then continue.';
  }
  if (type === 'magiclink') {
    return 'Continue into Pacarion.';
  }
  if (type === 'email_change') {
    return 'Your email address is updated. Continue to sign in.';
  }
  return 'Your email is ready. Continue to sign in, or to checkout if you still need to choose a plan.';
}

module.exports = {
  AUTH_CONFIRM_PATH,
  AUTH_CONFIRM_URL,
  OTP_TYPES,
  readAuthConfirm,
  confirmSuccessTitle,
  confirmSuccessBody,
};
